import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import SeccionPageHeader from '../../Utils/SeccionPageHeader';
import CargandoSpinner from '../../Utils/CargandoSpinner';
import { useAuth } from '../../../Auth/AuthContext';
import apiService from '../../../Auth/apiService';

export default function CambiarPassword(){
    const { token, user } = useAuth();
    const [cargando, setCargando] = React.useState(false);
    const validationSchema = Yup.object().shape({
        password: Yup.string()
        .required('Contraseña requerida')
        .min(8, 'Contraseña debe tener minimo ocho caracteres')
        .matches(/[A-Z]/, 'Contraseña debe tener minimo una letra mayuscula')
        .matches(/[a-z]/, 'Contraseña debe tener minimo una letra minuscula')
        .matches(/\d/, 'Contraseña debe tener minimo un numero')
        .matches(/[@$!%*?&#+-]/, 'Contraseña debe tener minimo un caracter especial'),
        confirmPassword: Yup.string()
        .required('Confirmar contraseña')
        .oneOf([Yup.ref('password')], 'Las contraseñas deben se iguales.'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };
    const { register, handleSubmit, formState: { errors } } = useForm(formOptions);
    const onSubmit = async data => {
        const url = '/users/cambiarpassword';
        if (data.password !== data.confirmPassword) {
            alert('Las contraseñas no coinciden');
            return;
        }
        const obj = { usrId: user, password: data.password, oldpassword: data.oldpassword };
        setCargando(true);
        try {
            const response = await apiService.post(url, obj, token);
            if (response.statusText === 'OK') {
                import('sweetalert2').then(Swal => {
                    Swal.default.fire({
                        icon: 'success',
                        title: '¡Éxito!',
                        text: 'Contraseña actualizada correctamente',
                    });
                });
            } else {
                import('sweetalert2').then(Swal => {
                    Swal.default.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al actualizar la contraseña',
                    });
                });
            }
        } catch (error) {
            if (error.response && error.response.status === 409) {
                import('sweetalert2').then(Swal => {
                    Swal.default.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error.response.data,
                    });
                });
            } else {
                console.error('Error:', error);
                import('sweetalert2').then(Swal => {
                    Swal.default.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al actualizar la contraseña',
                    });
                });
            }
        } finally {
            setCargando(false);
        }
    };

    
    return (
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Cambiar contraseña"
                idCabezaFamilia="0"
                url="/"
                nombreurl="Tablero"
                nombreform="Cambiar contraseña"
            />
            <CargandoSpinner Cargando={cargando} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                    <div className="col-md-7">
                        <div className="card card-info">
                        <div className="card-header">
                            <h3 className="card-title">Gestionar contraseña</h3>
                        </div>
                        
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                                <div className="form-group">
                                    <label htmlFor="oldpassword">Contraseña anterior</label>
                                    <input 
                                        type="password" 
                                        {...register('oldpassword', { required: 'Debe digitar la contraseña anterior' })} 
                                        className="form-control" 
                                        id="oldpassword" 
                                        placeholder="Contraseña anterior"
                                    />
                                    {errors.oldpassword && <p style={{color: 'red'}}>{errors.oldpassword.message}</p>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="password">Nueva contraseña</label>
                                    <input 
                                        type="password" 
                                        {...register('password', {  })} 
                                        className="form-control" 
                                        id="password" 
                                        placeholder="Contraseña"
                                        autoComplete="new-password"
                                    />
                                    {errors.password && <p style={{color: 'red'}}>{errors.password.message}</p>}
                                    <small className="form-text text-muted">
                                        La contraseña debe tener al menos 8 caracteres, una may&uacute;scula, una min&uacute;scula, un n&uacute;mero y un caracter especial (@$!%*?&#+-).
                                    </small>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="confirmPassword">Confirmar contraseña</label>
                                    <input 
                                        type="password" 
                                        {...register('confirmPassword')} 
                                        className="form-control" 
                                        id="confirmPassword" 
                                        placeholder="Confirmar contraseña"
                                        autoComplete="new-password"
                                    />
                                    {errors.confirmPassword && <p style={{color: 'red'}}>{errors.confirmPassword.message}</p>}
                                </div>
                            </div>
                            <div className="card-footer">
                            <button type="submit"  className="btn btn-info">Actualizar</button>
                            </div>
                        </form>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        </div>
    );
};
CambiarPassword.propTypes = {
    element: PropTypes.any,
};
